import Text from 'app/src/kit/Text'
import { styled } from 'styled-components'

const AccountSectionDescription = styled(Text)`
  max-width: 640px;
`

export default AccountSectionDescription
